import { DateTime } from 'luxon';
import { TIMEZONE_ABBREVIATIONS } from '../constants';

/**
 * Format a date/time with timezone for activity timeline
 * Returns: { time, timezoneAbbr, date }
 * Example: { time: "11:52 AM", timezoneAbbr: "PT", date: "8/20/25" }
 *
 * @param {string} isoTimestamp - ISO 8601 timestamp
 * @param {string} timezone - Location timezone (e.g., 'America/Los_Angeles')
 * @returns {object} { time, timezoneAbbr, date } or null if invalid
 */
export const formatActivityDateTime = (isoTimestamp, timezone) => {
  if (!isoTimestamp) return null;

  const zone = timezone || 'UTC';
  const dt = DateTime.fromISO(isoTimestamp, { zone });

  if (!dt.isValid) return null;

  return {
    time: dt.toFormat('h:mm a'), // "11:52 AM"
    timezoneAbbr: TIMEZONE_ABBREVIATIONS[timezone] || '',
    date: dt.toFormat('M/d/yy'), // "8/20/25"
  };
};
